/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AutoLogin from '@/middleware/autoLogin.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AutoLogin,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/manage-nimble/users',
          name: 'manage-nimble',
          component: () => import('@/views/pages/manage-nimble/ManageNimbleUsers.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage User', active: true }
            ],
            pageTitle: 'Manage User',
            rule: 'editor'
          }
        },
        {
          path: '/pages/tenants',
          name: 'tenants-home',
          component: () => import('@/views/pages/tenants/TenantHome.vue'),
          children: [
            {
              path: '',
              name: 'tenants-list',
              component: () => import('@/views/pages/tenants/TenantList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Manage Tenants', active: true }
                ],
                pageTitle: 'Manage Tenants',
                rule: 'editor'
              }
            },
            {
              path: ':id',
              name: 'tenants-details-tab',
              component: () => import('@/views/pages/tenants/TenantDetailsTabs'),
              meta: {
                parent: 'tenants-list',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Tenant list', url: '/pages/tenants' },
                  { title: 'Tenant Details', active: true }
                ],
                pageTitle: 'Tenant Details',
              }
            },
            {
              path: ':id/suppliers/:supplier_id',
              name: 'tenants-supplier-home',
              component: () => import('@/views/pages/tenants/tabs/rm-suppliers/RmSupplierHome'),
              meta: {
                parent: 'tenants-list',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'RM Suppliers', url: '..?step=7' },
                  { title: 'Supplier View', active: true }
                ],
                pageTitle: 'Suppliers',
              }
            },
            {
              path: ':id/channel-partners/:partner_id',
              name: 'tenants-channel-partner-home',
              component: () => import('@/views/pages/tenants/tabs/channel-partners/ChannelPartnerHome.vue'),
              meta: {
                parent: 'tenants-list',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Channel Partners', url: '..?step=8' },
                  { title: 'Channel Partner View', active: true }
                ],
                pageTitle: 'Channel Partner',
              }
            },
          ]
        },
        {
          path: '/pages/help-tags',
          name: 'manage-help-tags',
          component: () => import('@/views/pages/helper-tag/HelperTagList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Help Guides', active: true }
            ],
            pageTitle: 'Manage Help Guides',
            rule: 'editor'
          }
        },
        {
          path: '/pages/help-tags/create',
          name: 'help-tags-create',
          component: () => import('@/views/pages/helper-tag/CreateHelperTag.vue'),
          meta: {
            parent: 'manage-help-tags',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Help Guides', url: '/pages/help-tags' },
              { title: 'Create Help Guide', active: true }
            ],
            pageTitle: 'Create Help Tag',
            rule: 'editor'
          }
        },
        {
          path: '/pages/help-tags/:id',
          name: 'help-tags-details',
          component: () => import('@/views/pages/helper-tag/HelperTagDetails.vue'),
          meta: {
            parent: 'manage-help-tags',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Help Guides', url: '/pages/help-tags' },
              { title: 'Help Guide Details', active: true }
            ],
            pageTitle: 'Help Tag Details',
            rule: 'editor'
          }
        },
        {
          path: '/pages/help-tags-categories',
          name: 'help-tags-categories',
          component: () => import('@/views/pages/helper-tag/HelperTagCategoryList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Help Guide Categories', active: true }
            ],
            pageTitle: 'Help Guide Categories',
            rule: 'editor'
          }
        },
        {
          path: '/pages/pricing-tiers',
          name: 'manage-pricing-tiers',
          component: () => import('@/views/pages/pricing-tiers/PricingTierList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Pricing Tiers', active: true }
            ],
            pageTitle: 'Manage Pricing Tiers',
            rule: 'editor'
          }
        },
        {
          path: '/pages/pricing-tiers/create',
          name: 'pricing-tiers-create',
          component: () => import('@/views/pages/pricing-tiers/PricingTierCreate.vue'),
          meta: {
            parent: 'manage-pricing-tiers',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pricing Tier Create', active: true }
            ],
            pageTitle: 'Pricing Tier Create',
            rule: 'editor'
          }
        },
        {
          path: '/pages/pricing-tiers/:id',
          name: 'pricing-tiers-details',
          component: () => import('@/views/pages/pricing-tiers/PricingTierView.vue'),
          meta: {
            parent: 'manage-pricing-tiers',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pricing Tier Details', active: true }
            ],
            pageTitle: 'Pricing Tier Details',
            rule: 'editor'
          }
        },
        {
          path: '/pages/channel-partners',
          name: 'manage-channel-partners',
          component: () => import('@/views/pages/channel-partners/ChannelPartnersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manage Channel Partners', active: true }
            ],
            pageTitle: 'Manage Channel Partners',
            rule: 'editor'
          }
        },
        {
          path: '/pages/channel-partners/:partner_id',
          name: 'channel-partner-details',
          component: () => import('@/views/pages/channel-partners/ChannelPartnerHome.vue'),
          meta: {
            parent: 'manage-channel-partners',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Channel Partners', url: '/pages/channel-partners' },
              { title: 'Details', active: true }
            ],
            pageTitle: 'Manage Channel Partners',
            rule: 'editor'
          }
        },
        {
          path: '/pages/partner-customers',
          name: 'partner-customers',
          component: () => import('@/views/pages/channel-partner-customer/ChannelPartnerCustomerList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Partner Customers', active: true }
            ],
            pageTitle: 'Manage Partner Customers',
            rule: 'editor'
          }
        },
        {
          path: '/pages/partner-users',
          name: 'partner-users',
          component: () => import('@/views/pages/channel-partner-customer/ChannelPartnerUsersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Partner Users', active: true }
            ],
            pageTitle: 'Manage Partner Users',
            rule: 'editor'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      redirect: '/page/login',
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          beforeEnter: AutoLogin,
        },
        {
          path: '/pages/test',
          name: 'page-test',
          component: () => import('@/views/Page2.vue')
        },
        {
          path: '/pages/email-verification/:code',
          name: 'page-verification',
          component: () => import('@/views/pages/EmailVerification.vue')
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/pages/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  const activePopup = document.getElementById('popup')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  if (activePopup) {
    activePopup.style.display = 'none'
  }
})

export default router
